import { ClubAddress } from '@/types/club.model';

export const parseGooglePlace = (
  place: google.maps.places.PlaceResult,
): ClubAddress => {
  const getComponent = (type: string) =>
    place.address_components!.find((c) => c.types.includes(type));

  const streetNumber = getComponent('street_number')?.long_name || '';
  const route = getComponent('route')?.long_name || '';
  const postalCode = getComponent('postal_code')?.long_name || '';
  const postalCodeNormalize = postalCode.replace(/[A-Z]/g, '');
  const locality = getComponent('locality')?.long_name;
  const adminLevel2 = getComponent('administrative_area_level_2')?.long_name;
  const state = getComponent('administrative_area_level_1')?.long_name || '';
  const countryComponent = getComponent('country');

  const latitude = place.geometry!.location!.lat();
  const longitude = place.geometry!.location!.lng();

  return {
    zipCode: postalCodeNormalize,
    street: `${route} ${streetNumber}`.trim(),
    fullCoordinates: `${latitude},${longitude}`,
    latitude,
    longitude,
    state,
    city: locality || adminLevel2 || '',
    country: {
      isoCode: countryComponent?.short_name || '',
      name: countryComponent?.long_name || '',
      phonePrefix: getPhonePrefixByCountryCode(
        countryComponent?.short_name || '',
      ),
    },
    timezone: '',
  };
};

const getPhonePrefixByCountryCode = (code: string): string => {
  const phonePrefixes: Record<string, string> = {
    AR: '+54',
    US: '+1',
    BR: '+55',
    MX: '+52',
    ES: '+34',
  };
  return phonePrefixes[code] || '';
};
